export default __webpack_public_path__ + "static/media/c0919a080cdded71ac4e6bab29a34188.ed7008a4.svg";